// extracted by mini-css-extract-plugin
module.exports = {"invalidFileType":"InvalidFileType_invalidFileType__1-lAQ"};